import { render } from "./slide-11.vue?vue&type=template&id=73a96b2d&scoped=true"
import script from "./slide-11.vue?vue&type=script&lang=js"
export * from "./slide-11.vue?vue&type=script&lang=js"

import "./slide-11.vue?vue&type=style&index=0&id=73a96b2d&lang=scss&scoped=true"

import exportComponent from "/Users/dima/Projects/OrangeStatic/rise-homestories/public/themes/rise-theme/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73a96b2d"]])

export default __exports__